import { useEffect, useState } from "react";
import useRequest from "./use-req";

const BVN_STATUS_ACCOUNT_EMAIL = "support@vouchlinks.com";

// BVN verification is only meaningful for this one tenant right now — every
// other org's customer records have no bvn_hash at all, so the field would
// just read "Unverified" for everyone else. Gated by the logged-in
// account's own email off GET /auth/get_userdata rather than anything
// customer-specific. Shared by the Customers table and the customer detail
// drawer's Basic Info tab so both stay in sync.
export function useBvnStatusVisibility(): boolean {
  const [visible, setVisible] = useState(false);
  const token = localStorage.getItem("authToken");
  const { makeRequest: getUserData } = useRequest("/auth/get_userdata", "GET", {
    Authorization: `Bearer ${token}`,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [response] = await getUserData();
      if (cancelled) return;
      const email = response?.payload?.email;
      setVisible(typeof email === "string" && email.toLowerCase() === BVN_STATUS_ACCOUNT_EMAIL);
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return visible;
}
